module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icons/gotop-b65baedf1692865309225d327c5f19b3.svg&quot;;"